// ----------------------------------------------------------------------------
// Snippet: Free Shipping Progress
// ----------------------------------------------------------------------------

import $ from 'jquery';
import {formatMoney} from '@shopify/theme-currency';
import { cartSubtotalUpdate } from '../../snippets/cart-js/ajax-add-cart';

Shopify.AjaxifyCartPage = (function($){

    var _config = {
        itemQuantitySelector    : '.cart__quantity',
        itemRemoveBtn           : '.cart__remove--ajax',
        shopifyAjaxCartURL      : window.localeUrl+'/cart.js',
        quantityInputDelayTime  : 500, // in miliseconds
        cartSubtotalSelector    : '.cart__subtotal-price',
        cartUndoMessageSelector : '.cart__undo-message',
        cartUndoButton          : '.cart__undo--ajax',
        checkoutButton          : '[name="checkout"]',
    };

    var _getInventory = function() {

        return $.ajax({
            type: "GET",
            url: window.localeUrl+'/cart?view=max-qty',
        })
    }

    var _init = function(){

        $(document).ready(function(){

            $("body").on('click', _config.cartUndoButton, function(e){
                e.preventDefault();

                // Get the line item id
                var $selectedLineItemId       = $(this).data('line-item-id'),
                    $selectedLineItemQuantity = $(this).data('line-item-quantity');

                $.ajax({
                    type: "POST",
                    url: window.localeUrl+'/cart/add.js',
                    data: { items: [ {quantity: $selectedLineItemQuantity, id: $selectedLineItemId} ] },
                    dataType: 'json',
                    success: function(data) {

                        location.reload();

                    },
                    error: function(XMLHttpRequest, textStatus, error) {

                        var $response = XMLHttpRequest.responseJSON;
                        var $message = "<p>"+$response.description+"</p>";

                        $(_config.cartUndoMessageSelector).replaceWith($message);
                    }
                });
            })

            $("body").on('click', _config.itemRemoveBtn, function(e){
                e.preventDefault();

                // Get the line item info
                var $this                     = $(this),
                    $selectedLineItemId       = $this.data('line-item-id'),
                    $selectedLineItemTitle    = $this.data('line-item-title'),
                    $selectedLineItemQuantity = $this.data('line-item-quantity'),
                    $cartRow                  = $this.parents('.cart__row');

                // Remove the line item by updating its quantity to 0
                $.ajax({
                    type: "POST",
                    url: window.localeUrl+'/cart/change.js',
                    data: { quantity: 0, id: $selectedLineItemId },
                    dataType: 'json',
                    success: function() {

                        if ( $this.data('undo') == false ) { // If removing an out of stock product - refresh the page
                            location.reload();
                        }else{
                            $('.cart__item--total-wrapper .product__price').each(function(){
                                            $(this).addClass('loading');
                                        });
                            $('.cart-info__subtotal').addClass('loading');
                            $('.cart__subtotal-price').addClass('loading');

                            // Update free shipping progress
                            Shopify.freeShippingProgress.init();

                            // Update free gift progress
                            Shopify.freeGiftProgress.init($selectedLineItemId);

                            //Shopify.freeGiftProgress.giftUpdate();

                            // Remove line item row
                            $cartRow.remove();

                            $.ajax({
                                url: _config.shopifyAjaxCartURL,
                                cache: false,
                                dataType: "json",
                                success: function(cart) {
                                    var $cartSubtotal = formatMoney(cart.items_subtotal_price, theme.moneyFormat);
                                    $(_config.cartSubtotalSelector).text($cartSubtotal);

                                    cartSubtotalUpdate(cart);

                                    // Generate Undo message
                                    var $message = "";

                                    $message += "<p>";
                                        $message += $selectedLineItemTitle + ' ' + window.translations.cartProductRemovedMessage ;
                                        $message += " <a href='' class='cart__undo cart__undo--ajax' data-line-item-id='"+$selectedLineItemId+"' data-line-item-quantity='"+$selectedLineItemQuantity+"' >";
                                            $message += window.translations.cartUndoLabel;
                                        $message += "</a>";
                                    $message += "</p>";

                                    if ($(_config.cartUndoMessageSelector).is(':empty')){
                                        $(_config.cartUndoMessageSelector).empty().html($message);
                                    }else{

                                        $(_config.cartUndoMessageSelector).fadeOut(200, function(){
                                            $(_config.cartUndoMessageSelector).empty().html($message);
                                            $(_config.cartUndoMessageSelector).fadeIn(200);
                                        });
                                    }

                                    $('.cart__item--total-wrapper .product__price').each(function(){
                                        $(this).removeClass('loading');
                                    });
                                    $('.cart-info__subtotal').removeClass('loading');
                                    $('.cart__subtotal-price').removeClass('loading');
                                }
                            });

                            setTimeout(function () {
                                $('.cart__item--total-wrapper .product__price').each(function(){
                                    $(this).removeClass('loading');
                                });
                                $('.cart-info__subtotal').removeClass('loading');
                                $('.cart__subtotal-price').removeClass('loading');
                            }, 1000);
                        }

                    },
                    error: function(XMLHttpRequest, textStatus) {
                        /* error code */
                    }
                });
            });

            $("body").on('change', _config.itemQuantitySelector, function(){

                var $this      = $(this),
                    $cartRow   = $this.parents('.cart__row'),
                    $inventory = _getInventory();



                setTimeout(function(){

                    $.when(_getInventory()).done(function(data) {

                        var $inventory                          = $.parseJSON(data),
                            $selectedLineItemId                 = $this.attr('data-line-item-id'),
                            $selectedProductHandle              = $this.attr('data-handle'),
                            $selectedLineItemPrice              = parseInt($this.attr('data-price')),
                            $selectedLineItemCompareAtPrice = parseInt($this.attr('data-compare-at-price')),
                            $selectedLineItemInventoryPolicy = $this.attr('data-inventory-policy'),
                            $selectedLineItemInventoryManagement = $this.attr('data-inventory-management'),
                            $selectedLineItemTotalPriceSelector = $this.parents('.cart__item--quantity').siblings('.cart__item--total');

                        $.each($inventory, function(key, value){


                            if ( key == $selectedLineItemId) {

                                var $availableQty = parseInt(value);
                                if ( $availableQty <= 0 && $selectedLineItemInventoryPolicy != 'continue' && $selectedLineItemInventoryManagement != 'none' ) { // If out of stock
                                    var $selectedQuantity = $this.val();
                                    $(_config.checkoutButton).prop('disabled', true);
                                    $cartRow.find('.cart__item--message').empty().append("<p>This item is no longer available. Please <a data-undo='false' href='' data-line-item-id='"+$selectedLineItemId+"' class='cart__remove cart__remove--ajax'>remove this item</a> before continuing to checkout.</p>");
                                }else{

                                    if ( $availableQty < parseInt($this.val()) && $selectedLineItemInventoryPolicy != 'continue' && $selectedLineItemInventoryManagement != 'none') { // If available stock is less than line item qty
                                        $this.val($availableQty);
                                        var $selectedQuantity = $availableQty;
                                    }else{
                                        var $selectedQuantity = $this.val();
                                    }
                                }

                                // Update data-line-item-quantity attribute for the remove button
                                $cartRow.find(_config.itemRemoveBtn).data('line-item-quantity', $selectedQuantity);
                                var $selectedLineItemTotalPrice = formatMoney($selectedQuantity*$selectedLineItemPrice, theme.moneyFormat);


                                $.ajax({
                                    type: "POST",
                                    url: window.localeUrl+'/cart/change.js',
                                    data: { quantity: $selectedQuantity, id: $selectedLineItemId },
                                    dataType: 'json',
                                    success: function() {
                                        $('.cart__item--total-wrapper .product__price').each(function(){
                                            $(this).addClass('loading');
                                        });
                                        $('.cart-info__subtotal').addClass('loading');
                                        $('.cart__subtotal-price').addClass('loading');


                                        // Update free shipping progress
                                        Shopify.freeShippingProgress.init();

                                        // Update free shipping progress
                                        Shopify.freeGiftProgress.init($selectedLineItemId);

                                        $.ajax({
                                            url: _config.shopifyAjaxCartURL,
                                            cache: false,
                                            dataType: "json",
                                            success: function(cart) {

                                                var $cartSubtotal = formatMoney(cart.items_subtotal_price, theme.moneyFormat);
                                                $(_config.cartSubtotalSelector).text($cartSubtotal);
                                                $selectedLineItemTotalPriceSelector.find('.cart__item--total-price').text($selectedLineItemTotalPrice);
                                                if ( $selectedLineItemCompareAtPrice > $selectedLineItemPrice ) {
                                                    var $selectedLineItemSaleTotalPrice = formatMoney($selectedQuantity*$selectedLineItemCompareAtPrice, theme.moneyFormat);
                                                    $selectedLineItemTotalPriceSelector.find('.product__price--total-sale').text($selectedLineItemSaleTotalPrice);
                                                }
                                                cartSubtotalUpdate(cart);


                                                setTimeout(function () {
                                                    $('.cart__item--total-wrapper .product__price').each(function(){
                                                        $(this).removeClass('loading');
                                                    });
                                                    $('.cart-info__subtotal').removeClass('loading');
                                                    $('.cart__subtotal-price').removeClass('loading');
                                                }, 1500);
                                            }
                                        });

                                    },
                                    error: function(XMLHttpRequest, textStatus) {
                                        /* error code */
                                    }
                                });
                            }
                        });
                    });

                },_config.quantityInputDelayTime);

            })
        })
    }
    return {
        init: function(params) {
                // Configuration
                params = params || {};
                // Merging with defaults.
                $.extend(_config, params);
                // Action
                $(function() {
                    _init();
                });
        },
        getConfig: function() {
            return _config;
        }
    }
})($)

$(document).ready(function(){
    Shopify.AjaxifyCartPage.init();
})
